<template>
  <div
    class="review-summary"
    role="region"
    aria-labelledby="review-summary-heading"
  >
    <h1 id="review-summary-heading" class="review-summary-heading">
      {{ $t("customer-dashboard.review-form.review-summary-title") }}
    </h1>
    <article class="review-card" aria-label="Review details">
      <div class="icon" aria-hidden="true">
        <review-score-icon :score="review.score" />
      </div>
      <div
        class="open-feedback"
        v-if="review.feedback"
        role="region"
        aria-label="Review feedback"
      >
        <p class="feedback-text">{{ review.feedback }}</p>
      </div>
      <div class="byline" v-if="review.public" aria-label="Review author">
        {{ customer.name }}
      </div>
    </article>
    <div class="review-options-summary" role="list" aria-label="Review options">
      <div class="review-option" role="listitem">
        <v-icon icon="check" class="check-icon" aria-hidden="true" />
        <span class="review-option-text">
          {{
            review.public
              ? $t("customer-dashboard.review-form.summary.review-is-public")
              : $t("customer-dashboard.review-form.summary.review-is-private")
          }}
        </span>
      </div>
      <div
        class="review-option"
        v-if="review.contact_requested"
        role="listitem"
      >
        <v-icon icon="check" class="check-icon" aria-hidden="true" />
        <span class="review-option-text">
          {{
            $t("customer-dashboard.review-form.summary.will_be_in_touch", {
              company_name: company.name
            })
          }}
        </span>
      </div>
    </div>
    <div class="review-controls">
      <router-link
        :to="{
          name: 'CustomerDashboard',
          query: queryForDashboard(),
          params: { locale: $i18n.locale }
        }"
        aria-label="Return to customer dashboard"
      >
        <button class="summary-ack-button" type="button">
          <i18n path="customer-dashboard.review-form.ready" tag="p" />
        </button>
      </router-link>
    </div>
  </div>
</template>

<script>
import ReviewScoreIcon from "@/components/review/ReviewScoreIcon.vue";
import vIcon from "@/components/v-components/v-icon.vue";

export default {
  name: "ReviewSummary",
  components: {
    ReviewScoreIcon,
    vIcon
  },
  props: {
    review: {
      score: {
        type: Number,
        required: true
      },
      feedback: {
        type: String,
        required: false
      },
      public: {
        type: Boolean,
        required: false
      },
      contact_requested: {
        type: Boolean,
        required: false
      }
    },
    customer: {
      name: {
        type: String,
        required: true
      }
    },
    company: {
      name: {
        type: String,
        required: true
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    queryForDashboard() {
      if (this.$route.query?.score) {
        delete this.$route.query.score;
      }
      if (this.$route.query?.review_token) {
        delete this.$route.query?.review_token;
      }

      return this.$route.query;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/scss/components/review-form";
</style>
